export const VIRTUAL_AUDIO_DEVICE_IDS = new Set(['default', 'communications'])
